export function isExternalUrl(url: string | null | undefined): boolean {
  if (!url) return false
  return /^https?:\/\//i.test(url)
}

/**
 * Resolve `path` to an absolute URL rooted at `origin`. Pass-through for
 * already-absolute http(s) URLs. Empty/missing path returns the origin.
 *
 * Used by useSeo (canonical, og:url, og:image) and useJsonLd (Schema.org
 * `@id` / `url`) — both need every URL absolute against the canonical site
 * origin so SSR-baked metadata doesn't link relative.
 */
export function absolutize(origin: string, path: string): string {
  if (!path) return origin
  if (/^https?:\/\//i.test(path)) return path
  return origin.replace(/\/$/, '') + (path.startsWith('/') ? path : '/' + path)
}
